
export default {
  name: 'g-blog-post-tags',
  props: {
    tags: {
      required: true,
      type: Array,
    },
    region: {
      required: true,
      type: String,
    },
  },
  computed: {
    tagsWithLink() {
      return this.tags.filter(tag => {
        return tag.content.link.cached_url !== '';
      });
    },
    tagsWithoutLink() {
      return this.tags.filter(tag => {
        return tag.content.link.cached_url === '';
      });
    },
  },
  methods: {
    checkLink(url) {
      let region = `${this.region}/`;
      // as we do not have any /us in the url we make sure the us region is removed
      // and a tag can be linked to a help link which is on a subdomain
      // in that case there is no region on help link it's all /en/
      if (this.region === 'us' || url.cached_url.includes('help.deputy.com')) {
        region = '';
      }
      // on story link we just make sure we will redirect to the correct region
      if (url.linktype === 'story') {
        const regex = /\b(us|au|gb)\/\b/g;
        return url.cached_url.replace(regex, `/${region}`);
      } else {
        // we are doing this extra check here because until we have migrated all our pages to SB
        // we will probably have tags which link to a wordpress page
        const regex = /\bdeputy\.com\/(us|au|gb)?\/?\b/g;
        return url.cached_url.replace(regex, `deputy.com/${region}`);
      }
    },
  },
};
